import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import '@/utils/i18n'
import './index.css'
import App from './App.tsx'
import { createAppQueryClient } from '@/utils/queryClient'
import { RootErrorBoundary } from '@/components/RootErrorBoundary'
import { reportClientError } from '@/api/client-errors'

const queryClient = createAppQueryClient()

// Глобальные хендлеры — для ошибок ВНЕ React-дерева (тайм-ауты, async-код,
// сторонние библиотеки). Reactовские ошибки рендера ловит RootErrorBoundary.
// Защита от повторного навешивания при HMR.
if (!window.__stryzhErrorHandlersInstalled) {
  window.addEventListener('error', (event) => {
    void reportClientError({
      kind: 'error',
      message: event.message || 'window.onerror',
      stack: event.error?.stack ?? null,
      meta: {
        source: event.filename ?? null,
        line: event.lineno ?? null,
        column: event.colno ?? null,
      },
    })
  })
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason
    const message =
      reason instanceof Error
        ? reason.message
        : typeof reason === 'string'
          ? reason
          : 'unhandledrejection'
    const stack = reason instanceof Error ? reason.stack ?? null : null
    void reportClientError({ kind: 'promise', message, stack })
  })
  window.__stryzhErrorHandlersInstalled = true
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </RootErrorBoundary>
  </StrictMode>,
)
